import { BodyLargeTypography, Flex } from '@npco/zeller-design-system'
import styled from 'styled-components'

import { BREAKPOINT } from 'styles/breakpoints'

export const StyledOrderTerminalLink = styled.a`
  ${BodyLargeTypography};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.BLUE_1000};
  border-radius: 7px;
  outline: none;
  background-color: ${({ theme }) => theme.colors.WHITE};
  color: ${({ theme }) => theme.colors.BLUE_1000};
  transition: background-color 0.3s ease-out, border-color 0.3s ease-out;
  cursor: pointer;
  width: 100%;
  text-decoration: none;

  &:hover {
    border-color: ${({ theme }) => theme.colors.BLUE_400};
  }

  &:focus {
    background-color: ${({ theme }) => theme.colors.GREY_30};
    border-color: ${({ theme }) => theme.colors.BLUE_400};
  }
`

export const StyledButtonWrapper = styled(Flex)`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 1rem;
  background-color: ${({ theme }) => theme.colors.WHITE};

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    position: static;
    width: 13rem;
    padding: 0;
  }
`

export const StyledButtonPlaceholder = styled.div`
  height: 2rem;

  @media screen and (min-width: ${BREAKPOINT.XS}px) {
    height: 0;
  }
`
